import {
  type Decision,
  DECISION_KEYS,
  decisionColor,
} from '@/components/Affectations/useAffectationDecision';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  decision: Decision;
  disabled?: boolean;
  onClick: () => void;
};

/** Icône d'action pour approuver ou refuser une seule affectation. */
const DecisionActionIcon = ({ decision, disabled, onClick }: Props) => {
  const { t } = useTranslate();
  const label = t(DECISION_KEYS[decision].one.action);

  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        variant="subtle"
        color={decisionColor(decision)}
        disabled={disabled}
        onClick={onClick}
        aria-label={label}
      >
        {decision === 'approve' ? <IconCheck size={16} /> : <IconX size={16} />}
      </ActionIcon>
    </Tooltip>
  );
};

export default DecisionActionIcon;
